export var DateFilter;
(function (DateFilter) {
    DateFilter[DateFilter["None"] = 0] = "None";
    DateFilter[DateFilter["MinutesSince"] = 1] = "MinutesSince";
    DateFilter[DateFilter["HoursSince"] = 2] = "HoursSince";
    DateFilter[DateFilter["DaysSince"] = 3] = "DaysSince";
})(DateFilter || (DateFilter = {}));
